import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './static-page.magic.css.js';
import script from './static-page.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"static-page",attrs:{"part":"static-page"}},[(!_vm.hideHeader)?_c('magic-static-page-header',{staticClass:"header",attrs:{"part":"header","slug":_vm.slug,"variant":_vm.variant,"hide-title":_vm.hideTitle,"hide-image":_vm.hideImage,"hide-description":_vm.hideDescription,"use-image-for-mobile-bg":_vm.enhancedCoversOnStaticPages},on:{"contentLoadError":function($event){return _vm.onError()}}}):_vm._e(),_vm._v(" "),_c('magic-static-page-content',{staticClass:"content",attrs:{"part":"content","slug":_vm.slug,"variant":_vm.variant,"headless":"hideHeader"}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5dd25359_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5dd25359";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
